import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrInventoryStatus.ts
var t = () => e("inventoryStatus");
//#endregion
export { t as useTrInventoryStatus };
